import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../../utils/axiosInstance";

export const getSpotGoldApi = createAsyncThunk('spotGold', async () => {
    const response = await axiosInstance.get('/productSubCategory');
    return response.data;
});

const spotGoldSlice = createSlice({
    name: "spotGold",
    initialState: {
        spotGold: [],
        errors: [],
        loading: false
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getSpotGoldApi.pending, (state) => {
                state.loading = true;
            })
            .addCase(getSpotGoldApi.fulfilled, (state, action) => {
                state.spotGold = action.payload;
                state.loading = false;
            })
            .addCase(getSpotGoldApi.rejected, (state, action) => {
                state.errors.push(action.error.message);
                state.loading = false;
            });
    }
});

export default spotGoldSlice.reducer;
